import React from 'react';
import { useTranslation } from 'react-i18next';
import { tArray } from 'cityads-v3/i18n/utils';

import Article, { ArticleImage } from 'cityads-v3/components/Article';

export default function LostOrders(props) {
  const { t } = useTranslation(['LostOrdersArticle']);

  return (
    <Article
      title           = {t('title')}
      pageTitle       = {t('pageTitle')}
      pageDescription = {t('pageDescription')}
      pageKeywords    = {t('pageKeywords')}
      {...props}
    >
      {tArray(t, 'p1', 'p')}

      <ArticleImage
        src={require('./img1.png')}
      />

      {tArray(t, 'p2', 'p')}
    </Article>
  );
}
